export default __webpack_public_path__ + "static/media/companies-benefits-03.abd3caba.webp";